import IframeBridge from 'IframeBridge';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { findImage } from 'utils/Utils';

const DomesticCardErrorPage = () => {
  const { t } = useTranslation();

  const { paymentState } = usePaymentState();
  const returnType = window.sessionStorage.getItem('returnType');

  useEffect(() => {
    if (returnType === 'DIRECT') {
      closeProcess();
    }
  }, [returnType]);

  const closeProcess = () => {
    const PayConfig = paymentState;
    const returnObject = {
      status: 'FAIL',
      displayAmount: PayConfig?.requestAmount,
      displayCurrency: PayConfig?.requestCurrency,
      orderId: PayConfig?.orderId,
      productName: PayConfig?.productName,
      returnUrl: paymentState.returnUrl,
    };

    if (isMobile) {
      const url = new URL(PayConfig.returnUrl);
      const params = new URLSearchParams(url.search);

      params.set('status', 'FAIL');
      params.set('displayAmount', PayConfig?.requestAmount.toString());
      params.set('displayCurrency', PayConfig?.requestCurrency);
      params.set('orderId', PayConfig?.orderId);
      params.set('productName', PayConfig?.productName);

      window.location.href = url + '?' + params;
    } else {
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
      IframeBridge.sendViewOff(returnObject);
    }
  };

  const handleAllClose = e => {
    e.preventDefault();
    closeProcess();
  };

  return (
    <>
      <div className="completed">
        <div className="middle">
          <div className="icon">
            <img src={findImage('error.png')} />
          </div>
          <div className="title">{t('domestic_payment_error')}</div>
          <div className="text" style={{ whiteSpace: 'pre-line' }}>
            {t('domestic_payment_error_msg')}
          </div>
        </div>
      </div>
      <div className="completed-btn">
        <div className="box confirmBox">
          <button className="all-close" onClick={handleAllClose}>
            {t('close')}
          </button>
        </div>
      </div>
    </>
  );
};

export default DomesticCardErrorPage;
